<template>
  <div v-if="isEmptyItems" class="ds-control ds-custom-drop-tree_empty">
    <slot name="emptyItems"> 请双击或拖拽相关字段到此处 </slot>
  </div>
  <div v-else class="ds-control ds-custom-drop-tree">
    <DsfCustomDropTreeLogicNode :data="data">
      <template #default="{ data }">
        <slot name="item" :item="data"></slot>
      </template>
    </DsfCustomDropTreeLogicNode>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfCustomDropTree",
  ctrlCaption: "放置树",
  mixins: [$mixins.control],
  provide() {
    return {
      $customDropTree: this,
    };
  },
  design: {
    fit: true,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          logic: "AND",
          items: [],
        };
      },
    },
    containerEl: {
      // 默认是此组件的父容器
      type: Function,
    },
    logic: {
      type: Object,
      default() {
        return {
          AND: "与",
          OR: "或",
        };
      },
    },
    defaultLogic: {
      type: String,
      default: "AND",
    },
    changeLogic: {
      type: Function,
      default: (data) => {
        return data.logic == "OR" ? "AND" : "OR";
      },
    },
    accept: {
      // 控制哪个可拖拽（draggable）元素可被 droppable 接受。
      // 可以是一个方法，也可以是一个class
      type: [String, Function],
      default() {
        return "ds-custom-drop-tree_item";
      },
    },
    setData: {
      type: Function,
    },
    dragData: {
      // 拖拽的外界组件的数据
      type: Function,
      default: (ui) => {
        return ui.draggable.find(".nodeLabel").get(0)?.__vue__?.node.data || {};
      },
    },
    canDragAdd: {
      // 可以通过拖拽增加新的数据
      // 比如即席查询分组条件的数据，只能点击查询项里面'作为分组条件'添加
      type: Boolean,
      default: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dragStart: false
    };
  },
  computed: {
    getContainer() {
      // 获取父容器
      if (this.containerEl) {
        return this.containerEl;
      } else {
        return this.$el.parentNode;
      }
    },
    isEmptyItems() {
      // 是否为空数据
      return this.data.items.length > 0 ? false : true;
    },
  },
  watch: {
    isReadOnly(n, v) {
      this.buildTreeRelation();
      if (n) {
        $(this.getContainer).droppable("disable");
      } else {
        $(this.getContainer).droppable("enable");
      }
    },
  },
  created() {
    this.buildTreeRelation();
  },
  mounted() {
    // 绑定放置数据
    if (this.canDragAdd) {
      this.initDropContainer();
    }
  },
  methods: {
    acceptDrag(drag) {
      if (dsf.isFunction(this.accept)) {
        return this.accept(drag);
      } else if (this.accept == "*") {
        return true;
      } else {
        if (drag.hasClass(this.accept)) {
          return true;
        }else if(drag.hasClass("ds-custom-drop-tree_item")){
          return true;
        }
        return false;
      }
    },
    initDropContainer() {
      let _this = this;
      $(this.getContainer).droppable({
        accept: _this.acceptDrag,
        greedy: true,
        tolerance: "pointer",
        hoverClass: "drop-hover",
        drop($evt, ui) {
          let data = _this.dragData(ui);
          if (!dsf.isEmptyObject(data)) {
            _this.addNode(_this.dragData(ui));
          }
        },
        over(evt, ui) {
          if (!_this.isEmptyItems) {
            _this.dragAutoScroll({
              top: evt.clientY,
              left: evt.clientX,
            });
          }
        },
      });
    },
    dragAutoScroll(dragPos) {
      // 如果拖拽的元素超出了显示区域，滚动条位置将随之调整
      let box = $(this.getContainer); //左侧的整块区域
      let boxHeight = box.height(); //左侧高
      let boxOffset = box.offset(); //左侧距离顶部的高（此处为0）
      if (boxOffset.top > dragPos.top) {
        // 往上滚动
        box.scrollTop(box.scrollTop() - Math.abs(boxOffset.top - dragPos.top));
      } else if (boxOffset.top + boxHeight < dragPos.top) {
        // 往下滚动
        box.scrollTop(
          box.scrollTop() + Math.abs(boxOffset.top + boxHeight - dragPos.top)
        );
      }
    },
    // 添加节点到更目录
    addNode(data) {
      if (!this.isReadOnly) {
        this.data.items.push(this.setDataReal(data));
      }
    },
    setDataReal(data) {
      // 从指标到条件的数据
      let result = {};
      if (this.setData) {
        result = this.setData(data);
      } else {
        // 默认数据
        result = {
          code: data.$code,
          operator: "eq",
          valueKey: data.$valueKey + "_" + dsf.uuid(),
          dataType: data.type,
          format: null,
          value: null,
          value2: null, //用作介于和区间的第二个值
          field: data.remark,
          aggType: data.aggType,
        };
      }
      this.setNode(result);
      return result;
    },
    setNode(v) {
      if (!("$hash" in v)) {
        v["$hash"] = dsf.uuid();
      }
      v["isLeaf"] = !v.items || v.items.length <= 0;
      v["isGroup"] = dsf.isDef(v.logic);
    },
    //移除节点
    removeNode(data) {
      if (data && data.parent) {
        dsf.array.remove(data.parent.items || [], data);
        this.resetTree();
        this.$emit("removeBefore", data);
      }
    },
    resetTree() {
      this.filterInvalidNodes();
      this.buildTreeRelation();
    },
    filterInvalidNodes() {
      function fn(n) {
        if (!n.isRoot) {
          while (true) {
            if (n.isGroup && n.items.length == 1 && n.items[0]?.logic) {
              n = n.items[0];
            } else {
              break;
            }
          }
        }
        if (n.isGroup) {
          let items = [];
          for (let i = 0; i < n.items.length; i++) {
            let cn = fn(n.items[i]);
            cn && items.push(cn);
          }
          n.items = items;
          if (n.items && items.length > 0) {
            return n;
          }
          return null;
        } else {
          return n;
        }
      }
      let obj = fn(this.data);
      Object.assign(this.data, obj);
      this.buildTreeRelation();
    },
    buildTreeRelation() {
      dsf.deepForEach(
        this.data,
        (it, a, b, parent) => {
          if (it) {
            if (!("parent" in it)) {
              Object.defineProperty(it, "parent", {
                enumerable: false, //表示能否通过for in循环访问属性，默认值为true
                value: parent,
                writable: true, //表示能否修改属性的值。默认值为true。
              });
            } else {
              it.parent = parent;
            }
          }
        },
        { children: "items" }
      );
    },
  },
});
</script>